import { render, staticRenderFns } from "./sektorler.vue?vue&type=template&id=033aeac0&"
import script from "./sektorler.vue?vue&type=script&lang=js&"
export * from "./sektorler.vue?vue&type=script&lang=js&"
import style0 from "./sektorler.vue?vue&type=style&index=0&id=033aeac0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports